import { type CustomerAnalyticsMoodysReportDto } from '@zg-rentals/ts-customer-analytics-client';
import { View } from '@react-pdf/renderer';
import { styles } from './pdfStyles';
import {
  MarketTrendsPageWrapper,
  MarketTrendsParagraph,
  MarketTrendsSubHeading,
  MarketTrendsTextHeader,
} from './MarketTrendsComponents';

export const SubmarketExecutiveBrefingPage = ({ report }: { report: CustomerAnalyticsMoodysReportDto }) => {
  return (
    <MarketTrendsPageWrapper quarter={report.dataAsOfQuarter} year={report.dataAsOfYear}>
      <View style={styles.containerBase}>
        <MarketTrendsTextHeader
          headerText={
            report.executiveSummaryBySection.SUBMARKET_OVERVIEW
              ? 'Submarket Executive Briefing'
              : 'Market Executive Briefing'
          }
        />
        {!report.executiveSummaryBySection.SUBMARKET_OVERVIEW && report.executiveSummaryBySection.MARKET_OVERVIEW && (
          <>
            <MarketTrendsSubHeading heading="Market Overview" />
            <MarketTrendsParagraph>{report.executiveSummaryBySection.MARKET_OVERVIEW}</MarketTrendsParagraph>
          </>
        )}

        {report.executiveSummaryBySection.SUBMARKET_OVERVIEW && (
          <>
            <MarketTrendsSubHeading heading="Submarket Overview" />
            <MarketTrendsParagraph>{report.executiveSummaryBySection.SUBMARKET_OVERVIEW}</MarketTrendsParagraph>
          </>
        )}

        <MarketTrendsSubHeading heading="Asking and Effective Rent" />
        <MarketTrendsParagraph>{report.executiveSummaryBySection.ASKING_EFFECTIVE_RENT}</MarketTrendsParagraph>

        <MarketTrendsSubHeading heading="Competitive Inventory, Household formations, Absortions" />
        <MarketTrendsParagraph>{report.executiveSummaryBySection.COMPETITIVE_ANALYSIS}</MarketTrendsParagraph>

        <MarketTrendsSubHeading heading="Outlook" />
        <MarketTrendsParagraph>{report.executiveSummaryBySection.OUTLOOK}</MarketTrendsParagraph>
      </View>
    </MarketTrendsPageWrapper>
  );
};
